import { SalesHistory } from '@interfaces/reports/salesHistory';

export type PairedSalesHistory = {
  date: string;
  year: number;
  month: number;
  salesValue: number;
  salesCount: string;
  groupProfit: string;
  /** NULL, nunca zero: zero afirmaria que não vendeu num mês em que a comunidade não existia. */
  previousYearSalesValue: number | null;
};

/** A API manda o valor como string, e com duas séries o domínio do YAxis precisa dos dois números. */
const toNumber = (value: string) => {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : 0;
};

/** O par sai da própria resposta, que já vem mês a mês desde o começo da comunidade. */
export const pairPreviousYearSales = (
  data: SalesHistory[],
): PairedSalesHistory[] => {
  const byMonth = new Map(
    data.map((sale) => [`${sale.year}-${sale.month}`, sale]),
  );

  return data.map((sale) => {
    const previousYear = byMonth.get(`${sale.year - 1}-${sale.month}`);

    return {
      date: `${sale.month}/${sale.year}`,
      year: sale.year,
      month: sale.month,
      salesValue: toNumber(sale.salesValue),
      salesCount: sale.salesCount,
      groupProfit: sale.groupProfit,
      previousYearSalesValue: previousYear
        ? toNumber(previousYear.salesValue)
        : null,
    };
  });
};

/** Sem nenhum par, a legenda da segunda barra anunciaria algo que nunca aparece. */
export const hasPreviousYearPair = (points: PairedSalesHistory[]) =>
  points.some((point) => point.previousYearSalesValue !== null);
